// game objects
import { SkySymbol, soundService } from "@aceroll/core";

export class Bonus extends SkySymbol {
    async land() {
        const config = this.config.default;

        const landSound = config.sounds.land_2;

        soundService.play(landSound);

        await super.land();
    }
}